module.exports = __webpack_public_path__ + "img/hero-7.c1e77a95.png";